<template>
  <div id="personal">
    <div class="tit-rit">修改密码</div>
    <div class="el-pass-cont">
      <div class="el-sub-personal">
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="PassForm"
          :rules="rules"
          status-icon
          ref="PassForm"
        >
          <el-form-item label="旧密码" prop="oldPass">
            <el-input v-model="PassForm.oldPass" type="password"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPass">
            <el-input v-model="PassForm.newPass" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="copyPass">
            <el-input v-model="PassForm.copyPass" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('PassForm')">
              确认修改
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { isvalidPass } from "../resgiter/reg/validation.js";
export default {
  name: "Passuser",
  data() {
    let validatePass = (rule, value, callback) => {
      //校验密码
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!isvalidPass(value)) {
        callback(new Error("密码为6-16位之间的字母或者数字"));
      } else {
        if (this.PassForm.copyPass !== "") {
          this.$refs.PassForm.validateField("copyPass");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      //校验确认密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.PassForm.newPass) {
        callback(new Error("请保证两次密码一致!"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "right",
      PassForm: {
        oldPass: "",
        newPass: "",
        copyPass: "",
      },
      rules: {
        oldPass: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "密码为6-16位之间的字母或者数字",
            trigger: "blur",
          },
        ],
        newPass: [{ required: true, validator: validatePass, trigger: "blur" }],
        copyPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ModifoPass() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("Myinfo/updatePass", {
          token: tokens,
          oldpassword: this.PassForm.oldPass,
          password: this.PassForm.newPass,
          repassword: this.PassForm.copyPass,
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$message({
              message: res.data.msg, //弹出返回信息
              type: "warning",
              offset: 150,
            });
          } else {
            this.$message({
              message: res.data.msg, //弹出返回信息
              type: "success",
              offset: 150,
            });
            localStorage.removeItem("token");
            this.$router.push({ name: "Login" });
            this.$router.go(0);
          }
        })
        .catch((err) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            type: "warning",
            offset: 150,
          });
          this.$router.go(0);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ModifoPass();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
@import "./coms/user.css";
</style>>




// WEBPACK FOOTER //
// src/components/user/password_user.vue